export default "__VITE_ASSET__18112291__"